import { useEffect, useState } from 'react';

import { PERSISTED_KEYS_ON_SERVER } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';

const AGENT_NEW_LOZENGE_VISIBLE_DURATION_MS = 14 * 24 * 60 * 60 * 1000;

const getFirstSeenTimestamp = (value: unknown): number | null => {
	const timestamp = Number(value);
	return Number.isFinite(timestamp) && timestamp > 0 ? timestamp : null;
};

const shouldShowLozenge = (firstSeenTimestamp: number, now: number): boolean =>
	now - firstSeenTimestamp < AGENT_NEW_LOZENGE_VISIBLE_DURATION_MS;

export const useAgentNewLozenge = ({ isEnabled }: { isEnabled: boolean }): boolean => {
	const [shouldShowTimedAgentNewLozenge, setShouldShowTimedAgentNewLozenge] = useState(false);

	useEffect(() => {
		if (!isEnabled) {
			return;
		}

		try {
			const now = Date.now();
			const firstSeenTimestamp = getFirstSeenTimestamp(
				localStorage.getItem(
					PERSISTED_KEYS_ON_SERVER.PERSISTED_CREATE_AGENT_NEW_LOZENGE_FIRST_SEEN,
				),
			);

			if (firstSeenTimestamp) {
				setShouldShowTimedAgentNewLozenge(shouldShowLozenge(firstSeenTimestamp, now));
				return;
			}

			localStorage.setItem(
				PERSISTED_KEYS_ON_SERVER.PERSISTED_CREATE_AGENT_NEW_LOZENGE_FIRST_SEEN,
				String(now),
			);
			setShouldShowTimedAgentNewLozenge(true);
		} catch {
			setShouldShowTimedAgentNewLozenge(false);
		}
	}, [isEnabled]);

	return isEnabled ? shouldShowTimedAgentNewLozenge : true;
};
